import {
  request
} from '../until/axios.js'
// 新增
export function addsysMenu(pram) {
  return request({
    url: '/system/sysMenu',
    method: 'post',
    data: pram
  })

}
// 修改
export function editsysMenu(loginForm) {
  return request({
    url: '/system/sysMenu',
    method: 'put',
    data: loginForm
  })

}
// 删除
export function delsysMenu(pram) {
  return request({
    url: '/system/sysMenu',
    method: 'delete',
    data: pram
  })
}
// 按id查询
export function getsysMenu(id) {
  return request({
    url: '/system/sysMenu/get/' + id,
    method: 'GET',
    data: {}
  })
}
// 列表查询
export function listsysMenu(pram) {
  return request({
    url: '/system/sysMenu/list',
    method: 'post',
    data: pram
  })

}
// 分页查询
export function listPagesysMenu(pram) {
  return request({
    url: '/system/sysMenu/listPage',
    method: 'post',
    data: pram
  })

}
// 树结构列表
export function getlistTree(id) {
  return request({
    url: '/system/sysMenu/listTree',
    method: 'GET',
    data: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js